import { Routes } from '@angular/router';
import {CustomerPageComponent} from './pages/customer-page/customer-page.component';
import {OrderHistoryPageComponent} from './pages/order-history-page/order-history-page.component';

export const routes: Routes = [
  {
    path: 'order-history/:vismaId',
    component: OrderHistoryPageComponent,
  },
  {
    path: '**',
    component: CustomerPageComponent
  }
];
